var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.332397,
    width: 39.3457,
    height: 39.3457,
    rx: 7.15377,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7353 12.3657L18.6211 20.2355L12.6982 26.634H14.0312L19.2167 21.032L23.4064 26.634H27.9427L21.7258 18.3215L27.2388 12.3657H25.9058L21.1302 17.525L17.2716 12.3657H12.7353ZM14.6956 13.3476H16.7796L25.9821 25.6519H23.8981L14.6956 13.3476Z",
    fill: "url(#paint0_linear_2117_12)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2117_12",
    x1: 20.3188,
    y1: 12.693,
    x2: 20.3191,
    y2: 26.2519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6AE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#615447"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFTwitter);
export default __webpack_public_path__ + "static/media/f-twitter.255b630dfe612d46811ca3f0243252b9.svg";
export { ForwardRef as ReactComponent };